var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsaNewYorkTake5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 255 255",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.523 163.993H14.211l17.068-73.741h144.312l-17.068 73.741z",
    fill: "#00928f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.546 117.887v27.733H34.413v-27.733h-10.23v-8.827h30.601v8.827zM79.33 145.62l-1.98-6.429H66.373l-1.98 6.42h-10.86L66.8 109.06h10.23l13.267 36.56zm-5.115-16.872-2.353-9.138c-.471 2.451-1.048 4.493-2.353 9.138l-.675 2.398h6.056zm40.884 16.872-9.235-12.503v12.503H95.518v-36.56h10.345v4.28l-.16 8.41c1.519-2.407 9.768-12.69 9.768-12.69h12.557l-14.04 17.76 15.292 18.826zm18.755 0v-36.56h31.969v8.552h-21.961v4.857h10.807v8.374h-10.807v6.305h18.329v8.516z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M220.294 172.021h-70.322l20.496-89.042h70.322l-20.496 89.042z",
    fill: "#ca3092"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M193.715 155.211a42.163 42.163 0 0 1-22.902-6.518l6.056-11.109c5.133 3.064 11.482 5.328 17.236 5.328 6.891 0 9.422-2.531 9.422-6.82 0-4.138-2.602-6.278-7.193-6.278a15.363 15.363 0 0 0-9.884 3.064l-12.716-4.289 1.829-27.848h39.073v12.121h-27.049l-.462 7.415c2.984-1.456 6.216-2.371 11.544-2.371 11.544 0 19.146 5.825 19.146 17.76.027 12.503-8.862 19.545-24.101 19.545z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsaNewYorkTake5);
export default __webpack_public_path__ + "static/media/usa_new_york_take_5.be306d93b019d6749e60006bff1bab25.svg";
export { ForwardRef as ReactComponent };